export default __webpack_public_path__ + "static/media/seyi-ariyo.28157819.jpg";